import { Component, EventEmitter, Output, ViewChild, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'inc-patient-search',
  templateUrl: './patient-search.component.html',
  styleUrls: ['./patient-search.component.scss'],
})
export class PatientSearchComponent {
  placeholder = 'SEARCH_FOR_TAJ';
  mode = 'taj';

  @Input() debounce = 500;
  @Output() callSearch = new EventEmitter<{ mode: string, value: string }>();

  constructor() { }

  toggleMode() {
    this.mode = (this.mode === 'taj') ? 'name' : 'taj';
    this.placeholder = 'SEARCH_FOR_' + this.mode.toUpperCase();
  }

  search(data: any) {
    if (data && data.detail) {
      this.callSearch.emit({ mode: this.mode, value: data.detail.value });
    }
  }

  clear(data: any) {
    if (data && data.detail) {
      data.detail.value = '';
      this.callSearch.emit({ mode: this.mode, value: data.detail.value });
    }
  }

}
